import { QueryRequestHelper } from "@_common/query-request-helper";
import StaticHeader from "@components/common/Header/static-header";
import { allNavigationMenu } from "@components/common/LeftNavbar/PermissionJSON";
import Loader from "@components/common/Loader";
import {
  GetSpecificOrganizationToken,
  authSSOLogin,
  authSSOLoginWithCode,
} from "@services/auth.service";
import { getAllPermissionsWithToken } from "@services/roles.service";
import { getValue } from "@utils/lodash";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import _ from "lodash";

function SSOPage(props: any) {
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */
  useEffect(() => {
    const code = searchParams.get("code");
    if (code) {
      handleSSOLogin(code);
    }
  }, []);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const handleSSOLogin = async (code: string) => {
    try {
      let payload = {
        code: code,
        user_type: "CLIENT",
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await authSSOLoginWithCode(queryRequest);
      if (resp) {
          let getPermissions = await getAllPermissionsWithToken(
            getValue(resp, `data.accessToken`, "")
          );
          let response = getValue(
            getPermissions,
            `data.permissions`,
            []
          ).filter((item: any) => {
            if (item) return item;
          });
          let subTabPermissions = handlePermissionLogic(response);
          let link = optimizeNavigationMenus(
            getValue(subTabPermissions, `tabs`, []),
            getValue(subTabPermissions, `subTabs`, [])
          );
          localStorage.removeItem("cn");
          setIsLoading(false);
          localStorage.setItem(
            "accessToken",
            getValue(resp, `data.accessToken`, "")
          );
          localStorage.setItem(
            "refreshToken",
            getValue(resp, `data.refreshToken`, "")
          );
          localStorage.setItem("op", getValue(resp, `data.op`, ""));
          localStorage.setItem(
            "user",
            JSON.stringify(getValue(resp, `data.user`, ""))
          );
          window.location.href = `${link}`;
          localStorage.removeItem("hash");
          if (getValue(resp, `data.user.org_id`, "")) {
            getData(
              getValue(resp, `data.user.org_id`, ""),
              getValue(resp, `data.accessToken`, "")
            );
          }
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
    } catch (error) {}
  };

  const getData = async (id: string, token: string) => {
    try {
      let resp = await GetSpecificOrganizationToken(id, token);
      if (resp) {
        if (getValue(resp, `data.organisation_logo`, "")) {
          localStorage.setItem(
            "organisation_logo",
            getValue(resp, `data.organisation_logo`, "")
          );
        }
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                               Permission section                           */
  /* -------------------------------------------------------------------------- */
  const covertSecondString = (s: string) => {
    var lastIndex = s.lastIndexOf(":");
    if (lastIndex !== -1) {
      s = s.substring(0, lastIndex) + "-" + s.substring(lastIndex + 1);
    }
    return s;
  };
  const handlePermissionLogic = (response: any) => {
    let list =
      getValue(response, `length`, 0) > 0
        ? response.map((item: any) => {
            return covertSecondString(item).split("-").length === 2
              ? covertSecondString(item).split("-")
              : item.split(":");
          })
        : [];

    let arr: any = [];
    for (let i = 0; i < list.length; i++) {
      arr.push({
        tab: list[i][0],
        permission: list[i][1],
      });
    }
    var groupedPermission =
      getValue(arr, `length`, 0) > 0
        ? _.groupBy(arr, function (item: any) {
            return item.tab;
          })
        : [];
    var ObjectEntry: any = Object.entries(groupedPermission);
    const arr1: any = [];
    for (let i = 0; i < ObjectEntry.length; i++) {
      arr1.push({
        tab: ObjectEntry[i][0].split(":")[0],
        tabKey:
          ObjectEntry[i][0].split(":").length == 2
            ? ObjectEntry[i][0].split(":")[0] +
              "_" +
              ObjectEntry[i][0].split(":")[1]
            : ObjectEntry[i][0].split(":").length == 3
            ? ObjectEntry[i][0].split(":")[0] +
              "_" +
              ObjectEntry[i][0].split(":")[1] +
              "_" +
              ObjectEntry[i][0].split(":")[2]
            : ObjectEntry[i][0].split(":")[0],
        permissions: ObjectEntry[i][1].map((item: any) => item.permission),
      });
    }
    let tabs = _.uniq(arr1.map((item: any) => item.tab));
    let subTabs = _.uniq(arr1.map((item: any) => item.tabKey));
    return { tabs, subTabs };
  };

  function optimizeNavigationMenus(
    permissions: string[],
    subTabPermissionList: string[]
  ): any {
    let mainMenu: any =
      getValue(allNavigationMenu, `length`, 0) > 0 &&
      allNavigationMenu.filter((item: any) =>
        permissions.includes(getValue(item, `name`, ""))
      );
    let checkChildrensPermission =
      getValue(mainMenu, `length`, 0) > 0 &&
      mainMenu.map((menuItem: object) => {
        let menus =
          getValue(menuItem, `menu.length`, 0) > 0 &&
          getValue(menuItem, `menu`, []).map((item: object) => {
            let childrens =
              getValue(item, `childrens.length`, 0) > 0 &&
              getValue(item, `childrens`, []).filter((child: object) =>
                subTabPermissionList.includes(getValue(child, `name`, ""))
              );
            if (getValue(item, `childrens.length`, 0) > 0) {
              return {
                ...item,
                childLink: getValue(childrens, `[${0}].link`, ""),
                name: getValue(childrens, `[${0}].name`, ""),
                childrens: childrens,
              };
            } else {
              return {
                ...item,
                childLink: getValue(item, `link`, ""),
              };
            }
          });
        return {
          ...menuItem,
          menu: menus,
        };
      });

    let checkMenuPermission =
      getValue(checkChildrensPermission, `length`, 0) > 0 &&
      checkChildrensPermission.map((menuItem: object) => {
        let menus =
          getValue(menuItem, `menu.length`, 0) > 0
            ? getValue(menuItem, `menu`, []).filter((item: object) =>
                subTabPermissionList.includes(getValue(item, `name`, ""))
              )
            : [];

        return {
          ...menuItem,
          menu: menus,
        };
      });
    return getValue(checkMenuPermission, `[${0}].menu[${0}].childLink`, "");
    // return getValue(checkMenuPermission, `length`, 0) > 0
    //   ? checkMenuPermission.map((item: object) => ({
    //       ...item,
    //       childLink: getValue(item, `menu[${0}].childLink`, ""),
    //     }))
    //   : [];
  }
  return (
    <div>
      <StaticHeader />
      {isLoading ? <Loader /> : null}
    </div>
  );
}

export default SSOPage;
